export function buildLink(contentType) {
  switch (contentType) {
    case 'pitchdiagram':
      return '/diagram';
    case 'session':
      return '/session';
    default:
      return '/Content';
  }
}



// WEBPACK FOOTER //
// ./library/app/utils/buildLink.js